/**
 * usePageMeta — set document.title and meta name="description" + canonical for a page.
 * Restores previous values on unmount so SPA navigation keeps each page tidy.
 */
import { useEffect } from "react";

export function usePageMeta({ title, description, canonical } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    const descTag =
      document.querySelector('meta[name="description"]') ||
      (() => {
        const m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
        return m;
      })();
    const prevDesc = descTag.getAttribute("content");

    const canonicalTag =
      document.querySelector('link[rel="canonical"]') ||
      (() => {
        const l = document.createElement("link");
        l.rel = "canonical";
        document.head.appendChild(l);
        return l;
      })();
    const prevCanonical = canonicalTag.getAttribute("href");

    if (title) document.title = title;
    if (description) descTag.setAttribute("content", description);
    if (canonical) canonicalTag.setAttribute("href", canonical);

    return () => {
      document.title = prevTitle;
      if (prevDesc !== null) descTag.setAttribute("content", prevDesc);
      if (prevCanonical !== null) canonicalTag.setAttribute("href", prevCanonical);
    };
  }, [title, description, canonical]);
}
